import { IApproval, IApprovalDetail, ICompliance, ITaskDetail } from '@/types/tasksApprovals'
import { isCompliance, isFieldglassOutsourcedWorker, isFieldglassTimesheet, isSapLeaveRequest, isTNE } from '@/utils/approvals'

import AdditionalInfo from '../components/additionalInfo'
import Attachements from '../components/attachements'
import ChildItems from '../components/childItems'
import Fields from '../components/fields'
import MoreDetails from '../components/moreDetails'
import RequestPeriod from '../components/requestPeriod'

const Container = ({
    item,
    itemDetails,
    itemId,
}: {
    item: ICompliance | IApproval
    itemDetails: ITaskDetail | IApprovalDetail
    itemId: string
}) => {
    return (
        <>
            <Fields item={item} details={itemDetails} parentURL={itemDetails.action_source_system_parent_url} />
            {isSapLeaveRequest(item) && <RequestPeriod details={itemDetails} />}
            <Attachements
                item={itemDetails}
                systemID={item.system_id}
                itemID={itemId}
                type={isCompliance(item) ? 'compliances' : 'approvals'}
            />
            {'child_items' in itemDetails && itemDetails.child_items && (
                <ChildItems itemDetails={itemDetails} data={itemDetails.child_items} />
            )}
            {(isFieldglassTimesheet(item) || isFieldglassOutsourcedWorker(item) || isTNE(item)) && (
                <MoreDetails item={item} itemDetails={itemDetails} />
            )}
            {itemDetails.action_source_system_parent_url && (
                <AdditionalInfo parentURL={itemDetails.action_source_system_parent_url} systemID={item.system_id} />
            )}
        </>
    )
}

export default Container
